import { useContext, useEffect, useState } from "react";
import { ModalContext } from "../../../utils/modal/ModalProvider";
import styles from "../../../utils/modal/DetailModal.module.css";
import { IAM_PATH, IAM_SERVER_SERVICE_PRODUCT, IAM_SERVER_SERVICE_LICENSE } from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import { DialogEnum, showDialog } from "../../../utils/dialog/Dialog";
import Switch from "@mui/material/Switch";
import Loading from "../../../utils/loading/Loading";
import { containsXss } from "../../../utils/security/XssFilter";
import PlanTable from '../component/PlanTable';
import DetailModal from "../../../utils/modal/DetailModal";
import { PlanRegisterModal } from "./PlanRegisterModal";
import { format } from "date-fns";

/**
 * 사용자 상세정보 모달 Container
 * @param id
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const SoftwareDetailModal = ({ id, update }) => {
    const { closeModal } = useContext(ModalContext);
    const [loading, setLoading] = useState(true);
    const [isNull, setIsNull] = useState(false); //빈 값 확인

    const [formData, setFormData] = useState({
        id: '',
        product: ''
    });

    //--------------

    const { openModal } = useContext(ModalContext);
    const [usersLoading, setUsersLoading] = useState(false);

    //검색 조건
    const [selectedKind, setSelectedKind] = useState("");
    const [searchValue, setSearchValue] = useState('');

    //로그인된 사용자의 서비스 리스트
    // const [serviceList, setServiceList] = useState([]);
    // const {serviceList} = useServiceList();
    //서비스 아이디
    const [selectedServiceId, setSelectedServiceId] = useState('');

    //페이지 데이터, 선택 페이지
    // const [treeData, setTreeData] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    //선택 페이지 권한 목록
    // const [originalGroupUsers, setOriginalGroupUsers] = useState([]); // 최초 서버에서 받아온 권한 리스트(수정 전)
    const [selectedGroupUsers, setSelectedGroupUsers] = useState([]); // 화면에서 수정 중인 권한 리스트(수정 후)

    const [page, setPage] = useState(0);

    const listSize = 5; // 한 페이지당 보여줄 항목 수

    const [totalCount, setTotalCount] = useState(0);

    const [userInfo, setUserInfo] = useState({
        userId: sessionStorage.getItem("userId"),
        userName: sessionStorage.getItem("userName"),
        groupId: sessionStorage.getItem("groupId"),
        role: sessionStorage.getItem("role")
    })

    const [isMobileWindow, setIsMobileWindow] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
        };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const fetchPageData = async () => {
            setLoading(true);
            try {
                // 1. 그룹 정보 조회
                const url = `${IAM_PATH}${IAM_SERVER_SERVICE_PRODUCT}/get/${id}`;
                const res = await axios.get(url);
                const data = res.data.data;

                // 3. 폼 데이터 세팅
                setFormData({
                    id: id,
                    product: data.product || ''
                });
            } catch (e) {
                console.error(e);
                showDialog(DialogEnum.DEFAULT, "실패", "제품 정보 조회에 실패했습니다.");
            } finally {
                setLoading(false);
            }
        };
        fetchData(id, page, listSize);
        fetchPageData();
    }, [id, page]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    // 서비스스 등록 요청 API
    const handleUpdate = () => {
        for (let key in formData) {
            const value = formData[key];
            if (value === '') {
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            } else if (typeof value === 'string' && containsXss(value)) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }));
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }
        setIsNull(false);

        const pageParams = {
            id: formData.id,
            product: formData.product
        };

        const url = IAM_PATH + IAM_SERVER_SERVICE_PRODUCT + "/update";
        axios.post(url, pageParams)
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                    update();
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            });
    }

    const handleDelete = () => {
        const url = IAM_PATH + IAM_SERVER_SERVICE_PRODUCT + "/delete/" + formData.id;

        axios.post(url)
            .then((res) => {
                showDialog(DialogEnum.SUCCESS, res.data.code == 200 ? "성공" : "실패", res.data.message, res.data.code == 200 ? closeModal : undefined);
                update();
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
    }

    const fetchData = async (productId, page = 0, size = listSize, searchType, keyword) => {
        productId = id;

        const conditions = []
        if (!(searchType == "" || keyword == "")) {
            conditions.push({
                "operator": "",
                "conditions": [
                    { "field": "productId", "operator": "equals", "value": productId }
                ]
            });
        } else {
            conditions.push({
                "operator": "AND",
                "conditions": [
                    { "field": searchType, "operator": "like", "value": keyword },
                    { "field": "productId", "operator": "equals", "value": productId }
                ]
            });
        }

        const params = {
            startDate: 0,
            endDate: 0,
            page: page,
            size: size,
            sortField: ["id"],
            sortOrder: ["desc"],
            operator: "",
            conditions: conditions
        };

        const url = IAM_PATH + IAM_SERVER_SERVICE_LICENSE + "/all";
        await axios.post(url, params)
            .then((res) => {
                setTotalCount(res.data.data.totalCount);
                setSelectedGroupUsers(res.data.data.data.map(item => ({ ...item })));
            })
            .catch((e) => {
                console.error(e);
                showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
            })
            .finally(() => {
                setUsersLoading(false);
            });
    };

    const transformToTreeData = (data) => {
        return data.map(item => ({
            title: item.groupName,   // 트리에 표시될 텍스트
            // key: item.groupId.toString(), // 고유한 키 (문자열 추천)
            key: item.id, // 고유한 키 (문자열 추천)
            // userCount: item.userCount,
            children: item.children ? transformToTreeData(item.children) : []
        }));
    };

    const handleNextPage = () => {
        setPage((prevPage) => {
            const newPage = prevPage + 1;
            return newPage;
        });
    };

    const handlePrevPage = () => {
        setPage((prevPage) => {
            const newPage = Math.max(prevPage - 1, 0);
            return newPage;
        });
    };

    const handleSearch = (searchType, keyword) => {
        setPage(0);
        fetchData(id, 0, listSize, searchType, keyword)
    };


    // 권한만 다시 가져오는 함수
    const reloadGoupUsres = () => {
        fetchData(id, 0, listSize);
    }

    // 그룹 유저 추가 모달 핸들러
    const handleAddGroupUsers = () => {
        //그룹 선택해서 넘어가야함
        const modalContent = <PlanRegisterModal update={reloadGoupUsres}
            selectedServiceId={selectedServiceId} productId={id != null ? id : ""} productName={formData.product} />
        const modalOption = { modalTitle: '요금제 등록' }
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    // 그룹 유저 삭제
    const handleDeleteGroupUsers = (selectedIds) => {
        const url = IAM_PATH + IAM_SERVER_SERVICE_LICENSE + "/delete";

        axios.post(url, { ids: selectedIds })
            .then((res) => {
                showDialog(DialogEnum.SUCCESS, res.data.code == 200 ? "성공" : "실패", res.data.message);
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
            .finally(() => {
                //reload 안됨
                reloadGoupUsres();
            });
    };

    const handleRowClick = (id) => {

    };

    //----------------------------------------------------
    // // 삭제
    // const handleDeleteSelected = () => {
    //     if (selected.length > 0) {
    //     onDeleteUsers(selected); // 리스트로 넘김
    //     setSelected([]);
    //     }
    // };

    //----------------------------------------------------

    const [showGroupTree, setShowGroupTree] = useState(true);




    return (
        <div style={{ overflow: "auto" }}>
            {loading ? <Loading /> :
                <div>
                    <ul className={styles.layer__listWrap}>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>제품명</p>
                            <input className={styles.layer__listInput}
                                type={"text"}
                                name={"product"}
                                value={formData.product}
                                onChange={handleChange} />
                        </li>
                        <li className={styles.layer__list}>
                            <p className={styles.layer__listTit}>요금제</p>
                        </li>
                        <div style={{ display: "flex" }}>
                            <div className={styles.rightCont__cont__tableWrap} style={{ flex: "1" }}>
                                <div className={styles.permissionPanel}>
                                    <PlanTable
                                        groupId={selectedGroup != null ? selectedGroup.key : ""}
                                        users={selectedGroupUsers}
                                        onAddUser={handleAddGroupUsers}
                                        onDeleteUsers={handleDeleteGroupUsers}
                                        detailUser={handleRowClick}
                                        onPrevPage={handlePrevPage}
                                        onNextPage={handleNextPage}
                                        disablePrev={page === 0}
                                        disableNext={(page + 1) * listSize >= totalCount}
                                        pageNumber={page}
                                        totalCount={totalCount}
                                        listSize={listSize}
                                        searchValue={searchValue}
                                        setSearchValue={setSearchValue}
                                        onSearch={handleSearch}
                                        isMobileWindow={isMobileWindow}
                                    />
                                </div>
                            </div>
                        </div>
                    </ul>
                    {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
                    <div className={styles.layer__sensorBtnBox}>
                        <button className={styles.layer__deleteBtn} onClick={handleDelete}>삭제</button>
                        <button className={styles.layer__modifyBtn} onClick={handleUpdate}>수정</button>
                    </div>
                </div>
            }
        </div>
    );
}